// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sb-container {
  position: fixed;
  width: var(--snackbar-size);
  padding: 20px;
  z-index: var(--snackbar-zIndex);
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  height: auto;
}

.sb-topLeft {
  top: 0;
  bottom: auto;
  left: 0;
  right: auto;
}

.sb-topCenter {
  left: 50%;
  top: 0;
  bottom: auto;
  -webkit-transform: translateX(-50%);
          transform: translateX(-50%);
}

.sb-topRight {
  top: 0;
  bottom: auto;
  left: auto;
  right: 0;
}

.sb-bottomLeft {
  top: auto;
  bottom: 0px;
  left: 0px;
  right: auto;
}

.sb-bottomCenter {
  left: 50%;
  bottom: 0;
  top: auto;
  -webkit-transform: translateX(-50%);
          transform: translateX(-50%);
}

.sb-bottomRight {
  top: auto;
  bottom: 0px;
  left: auto;
  right: 0px;
  margin: 10px 0 0;
}

.sb-topLeft .sb-item,
.sb-topCenter .sb-item,
.sb-topRight .sb-item {
  margin: 10px 0 0;
}

.sb-bottomLeft .sb-item,
.sb-bottomCenter .sb-item,
.sb-bottomRight .sb-item {
  margin: 0 0 10px;
}

.sb-closeBtn {
  height: 20px;
  opacity: 1;
  overflow: hidden;
  padding: 2px;
  text-align: center;
  text-shadow: none;
  width: 20px;
  cursor: pointer;
  position: absolute;
  right: 5px;
  top: 5px;
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
  background: rgba(255, 255, 255, 0.6);
  border-radius: 100%;
}

.sb-closeBtn:hover {
  background: #fff;
}

.sb-closeIcon {
  display: block;
  font-size: 0;
  height: 100%;
  line-height: 0;
  overflow: hidden;
  position: relative;
  width: 100%;
}

.sb-closeIcon:after,
.sb-closeIcon:before {
  content: ' ';
  display: block;
  height: 2px;
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
  width: 12px;
  background-color: #222;
  opacity: 1;
  position: absolute;
}

.sb-closeIcon:before {
  left: 4px;
  top: 3px;

  -webkit-transform: rotate(45deg);

          transform: rotate(45deg);
  -webkit-transform-origin: 0px 50%;
          transform-origin: 0px 50%;
}

.sb-closeIcon:after {
  right: 3px;
  top: 5px;
  -webkit-transform: rotate(-45deg);
          transform: rotate(-45deg);
  -webkit-transform-origin: calc(100% - 3px) 50%;
          transform-origin: calc(100% - 3px) 50%;
}

.sb-title {
  font-size: 16px;
  font-weight: bold;
}

.sb-message {
  font-size: 14px;
  word-break: normal;
}

.sb-item {
  position: relative;
  -webkit-transition: height 300ms ease;
  transition: height 300ms ease;
  -webkit-animation: fadein 1s;
          animation: fadein 1s;
  padding: 20px;
  color: white;
  overflow: hidden;
  border-radius: 4px;
  -webkit-box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.2), 0 1px 18px 0 rgba(0, 0, 0, 0.12),
    0 3px 5px -1px rgba(0, 0, 0, 0.14);
          box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.2), 0 1px 18px 0 rgba(0, 0, 0, 0.12),
    0 3px 5px -1px rgba(0, 0, 0, 0.14);
  word-wrap: break-word;
}

.sb-item a {
  color: white;
  text-decoration: underline;
}

.sb-container .sb-hidden {
  padding-top: 0;
  padding-bottom: 0;
  margin-bottom: 0;
  height: 0;
  opacity: 0;
  -webkit-transition: all 300ms ease;
  transition: all 300ms ease;
}

.sb-item .sb-action,
.sb-error .sb-action,
.sb-warning .sb-action,
.sb-info .sb-action,
.sb-success .sb-action {
  margin-top: 10px;
  display: inline-block;
  padding: 6px 12px;
  margin-bottom: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-image: none;
  border: none;
  color: white;
}

.sb-success,
.sb-success .sb-action {
  background-color: var(--snackbar-success);
}

.sb-error,
.sb-error .sb-action {
  background-color: var(--snackbar-error);
}

.sb-warning,
.sb-warning .sb-action {
  background-color: var(--snackbar-warning);
}

.sb-info,
.sb-info .sb-action {
  background-color: var(--snackbar-info);
}

@-webkit-keyframes fadein {
  from {
    opacity: 0;
    top: 30px;
  }
  to {
    opacity: 1;
    top: 0;
  }
}

@keyframes fadein {
  from {
    opacity: 0;
    top: 30px;
  }
  to {
    opacity: 1;
    top: 0;
  }
}

/* Internet Explorer */
`, "",{"version":3,"sources":["webpack://./../../ui/src/components/snackbar/Snackbar.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,2BAA2B;EAC3B,aAAa;EACb,+BAA+B;EAC/B,8BAA8B;UACtB,sBAAsB;EAC9B,YAAY;AACd;;AAEA;EACE,MAAM;EACN,YAAY;EACZ,OAAO;EACP,WAAW;AACb;;AAEA;EACE,SAAS;EACT,MAAM;EACN,YAAY;EACZ,mCAAmC;UAC3B,2BAA2B;AACrC;;AAEA;EACE,MAAM;EACN,YAAY;EACZ,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,WAAW;EACX,SAAS;EACT,WAAW;AACb;;AAEA;EACE,SAAS;EACT,SAAS;EACT,SAAS;EACT,mCAAmC;UAC3B,2BAA2B;AACrC;;AAEA;EACE,SAAS;EACT,WAAW;EACX,UAAU;EACV,UAAU;EACV,gBAAgB;AAClB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,iCAAiC;EACjC,yBAAyB;EACzB,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;;EAEE,YAAY;EACZ,cAAc;EACd,WAAW;EACX,iCAAiC;EACjC,yBAAyB;EACzB,WAAW;EACX,sBAAsB;EACtB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,QAAQ;;EAER,gCAAgC;;UAExB,wBAAwB;EAChC,iCAAiC;UACzB,yBAAyB;AACnC;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,iCAAiC;UACzB,yBAAyB;EACjC,8CAA8C;UACtC,sCAAsC;AAChD;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,6BAA6B;EAC7B,4BAA4B;UACpB,oBAAoB;EAC5B,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB;sCACoC;UAC5B;sCAC4B;EACpC,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;;;;;EAKE,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,8BAA8B;EAC9B,0BAA0B;EAC1B,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;EACtB,YAAY;EACZ,YAAY;AACd;;AAEA;;EAEE,yCAAyC;AAC3C;;AAEA;;EAEE,uCAAuC;AACzC;;AAEA;;EAEE,yCAAyC;AAC3C;;AAEA;;EAEE,sCAAsC;AACxC;;AAEA;EACE;IACE,UAAU;IACV,SAAS;EACX;EACA;IACE,UAAU;IACV,MAAM;EACR;AACF;;AAEA;EACE;IACE,UAAU;IACV,SAAS;EACX;EACA;IACE,UAAU;IACV,MAAM;EACR;AACF;;AAEA,sBAAsB","sourcesContent":[".sb-container {\n  position: fixed;\n  width: var(--snackbar-size);\n  padding: 20px;\n  z-index: var(--snackbar-zIndex);\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  height: auto;\n}\n\n.sb-topLeft {\n  top: 0;\n  bottom: auto;\n  left: 0;\n  right: auto;\n}\n\n.sb-topCenter {\n  left: 50%;\n  top: 0;\n  bottom: auto;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n}\n\n.sb-topRight {\n  top: 0;\n  bottom: auto;\n  left: auto;\n  right: 0;\n}\n\n.sb-bottomLeft {\n  top: auto;\n  bottom: 0px;\n  left: 0px;\n  right: auto;\n}\n\n.sb-bottomCenter {\n  left: 50%;\n  bottom: 0;\n  top: auto;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n}\n\n.sb-bottomRight {\n  top: auto;\n  bottom: 0px;\n  left: auto;\n  right: 0px;\n  margin: 10px 0 0;\n}\n\n.sb-topLeft .sb-item,\n.sb-topCenter .sb-item,\n.sb-topRight .sb-item {\n  margin: 10px 0 0;\n}\n\n.sb-bottomLeft .sb-item,\n.sb-bottomCenter .sb-item,\n.sb-bottomRight .sb-item {\n  margin: 0 0 10px;\n}\n\n.sb-closeBtn {\n  height: 20px;\n  opacity: 1;\n  overflow: hidden;\n  padding: 2px;\n  text-align: center;\n  text-shadow: none;\n  width: 20px;\n  cursor: pointer;\n  position: absolute;\n  right: 5px;\n  top: 5px;\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n  background: rgba(255, 255, 255, 0.6);\n  border-radius: 100%;\n}\n\n.sb-closeBtn:hover {\n  background: #fff;\n}\n\n.sb-closeIcon {\n  display: block;\n  font-size: 0;\n  height: 100%;\n  line-height: 0;\n  overflow: hidden;\n  position: relative;\n  width: 100%;\n}\n\n.sb-closeIcon:after,\n.sb-closeIcon:before {\n  content: ' ';\n  display: block;\n  height: 2px;\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n  width: 12px;\n  background-color: #222;\n  opacity: 1;\n  position: absolute;\n}\n\n.sb-closeIcon:before {\n  left: 4px;\n  top: 3px;\n\n  -webkit-transform: rotate(45deg);\n\n          transform: rotate(45deg);\n  -webkit-transform-origin: 0px 50%;\n          transform-origin: 0px 50%;\n}\n\n.sb-closeIcon:after {\n  right: 3px;\n  top: 5px;\n  -webkit-transform: rotate(-45deg);\n          transform: rotate(-45deg);\n  -webkit-transform-origin: calc(100% - 3px) 50%;\n          transform-origin: calc(100% - 3px) 50%;\n}\n\n.sb-title {\n  font-size: 16px;\n  font-weight: bold;\n}\n\n.sb-message {\n  font-size: 14px;\n  word-break: normal;\n}\n\n.sb-item {\n  position: relative;\n  -webkit-transition: height 300ms ease;\n  transition: height 300ms ease;\n  -webkit-animation: fadein 1s;\n          animation: fadein 1s;\n  padding: 20px;\n  color: white;\n  overflow: hidden;\n  border-radius: 4px;\n  -webkit-box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.2), 0 1px 18px 0 rgba(0, 0, 0, 0.12),\n    0 3px 5px -1px rgba(0, 0, 0, 0.14);\n          box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.2), 0 1px 18px 0 rgba(0, 0, 0, 0.12),\n    0 3px 5px -1px rgba(0, 0, 0, 0.14);\n  word-wrap: break-word;\n}\n\n.sb-item a {\n  color: white;\n  text-decoration: underline;\n}\n\n.sb-container .sb-hidden {\n  padding-top: 0;\n  padding-bottom: 0;\n  margin-bottom: 0;\n  height: 0;\n  opacity: 0;\n  -webkit-transition: all 300ms ease;\n  transition: all 300ms ease;\n}\n\n.sb-item .sb-action,\n.sb-error .sb-action,\n.sb-warning .sb-action,\n.sb-info .sb-action,\n.sb-success .sb-action {\n  margin-top: 10px;\n  display: inline-block;\n  padding: 6px 12px;\n  margin-bottom: 0;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.42857143;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  -ms-touch-action: manipulation;\n  touch-action: manipulation;\n  cursor: pointer;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  background-image: none;\n  border: none;\n  color: white;\n}\n\n.sb-success,\n.sb-success .sb-action {\n  background-color: var(--snackbar-success);\n}\n\n.sb-error,\n.sb-error .sb-action {\n  background-color: var(--snackbar-error);\n}\n\n.sb-warning,\n.sb-warning .sb-action {\n  background-color: var(--snackbar-warning);\n}\n\n.sb-info,\n.sb-info .sb-action {\n  background-color: var(--snackbar-info);\n}\n\n@-webkit-keyframes fadein {\n  from {\n    opacity: 0;\n    top: 30px;\n  }\n  to {\n    opacity: 1;\n    top: 0;\n  }\n}\n\n@keyframes fadein {\n  from {\n    opacity: 0;\n    top: 30px;\n  }\n  to {\n    opacity: 1;\n    top: 0;\n  }\n}\n\n/* Internet Explorer */\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
